import React, { useState } from "react"
import {
  Box,
  Grid,
  Container,
  Typography,
  Button,
  Card,
  CardMedia,
  CardHeader,
  useTheme,
  useMediaQuery,
} from "@material-ui/core"
import { useStaticQuery, graphql, navigate } from "gatsby"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import styled from "styled-components"
import { Link } from "gatsby-theme-material-ui"
import firebase from "gatsby-plugin-firebase"

const queryString = require("query-string")

const SSlider = styled(Slider)`
  .slick-slide div {
    outline: none;
  }

  .hvr-glow {
    vertical-align: middle;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-property: box-shadow;
    transition-property: box-shadow;
  }
  .hvr-glow:hover,
  .hvr-glow:focus,
  .hvr-glow:active {
    box-shadow: 0 0px 20px -12px rgba(0, 0, 0, 0.3);
  }

  .slick-dots {
    bottom: -35px !important;

    li {
      margin: 0 1px;

      button:before {
        font-size: 10px !important;
      }
    }
  }
`

const Comp = () => {
  let theme = useTheme()
  let smaller = useMediaQuery(theme.breakpoints.down("md"))
  const [dragging] = useState(false)

  const { categories } = useStaticQuery(graphql`
    query CategoriesSliderQuery {
      categories: allHasura {
        category {
          id
          name
          product_room_categories {
            id
            product {
              id
              slug
              style {
                id
                name
              }
              presets {
                id
                size
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Box py={[8, 16]} textAlign="center">
      <Container maxWidth="xl" disableGutters={smaller}>
        <Grid container>
          <Grid item xs={12}>
            <Container maxWidth="md">
              <Typography
                variant="h3"
                component="h2"
                align="center"
                gutterBottom
              >
                Explore our custom furniture solutions
              </Typography>
              <br />
              <Typography
                variant="body1"
                color="textSecondary"
                align="center"
                paragraph
                gutterBottom
              >
                Start creating your unique furniture by choosing from our
                distinct furniture types.
                <br />
                <br />
                <b>Our prices start at $300</b>
              </Typography>
            </Container>
            <Box my={[8]}>
              <SSlider
                {...{
                  dots: true,
                  arrows: false,
                  infinite: true,
                  speed: 500,
                  slidesToShow: 6,
                  slidesToScroll: 0,
                  initialSlide: 0,
                  centerMode: true,
                  swipeToSlide: true,
                  focusOnSelect: true,
                  responsive: [
                    {
                      breakpoint: 1280,
                      settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                      },
                    },
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                      },
                    },
                    {
                      breakpoint: 700,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                      },
                    },
                  ],
                }}
              >
                {categories.category.map((c, i) => {
                  let selectedSize = ["S", "M", "L", "XL"][
                    Math.floor(Math.random() * 4)
                  ]

                  typeof window !== `undefined` &&
                    firebase
                      .analytics()
                      .logEvent(firebase.analytics.EventName.VIEW_ITEM_LIST, {
                        item_list_id: i.toString(),
                        item_list_name: "categories",
                        items: categories.category.map(item => {
                          return {
                            item_id: c.id,
                            item_name: c.name,
                            item_category:
                              c.product_room_categories[0].product.style.name,
                            item_variant: selectedSize,
                          }
                        }),
                      })

                  return (
                    <Box
                      p={1}
                      onClick={e => {
                        if (dragging) {
                          e.stopPropagation()
                        } else {
                          typeof window !== `undefined` &&
                            firebase
                              .analytics()
                              .logEvent(
                                firebase.analytics.EventName.SELECT_ITEM,
                                {
                                  item_list_id: i.toString(),
                                  item_list_name: "categories",
                                  items: [
                                    {
                                      item_id: c.id,
                                      item_name: c.name,
                                      item_category:
                                        c.product_room_categories[0].product
                                          .style.name,
                                      item_variant: selectedSize,
                                    },
                                  ],
                                }
                              )
                          navigate(
                            queryString.stringifyUrl(
                              {
                                url: "/shop",
                                query: {
                                  categories: [c.name.toLowerCase()],
                                  styles: ["air", "cube", "stacc"],
                                },
                              },
                              { arrayFormat: "bracket" }
                            )
                          )
                        }
                      }}
                    >
                      <Card className="hvr-glow" raised>
                        <CardMedia
                          style={{
                            height: "auto",
                            background: [
                              "rgba(255,225,227,1)",
                              "rgba(234,232,233,1)",
                              "rgba(234,255,237,1)",
                              "rgba(252,253,221,1)",
                              "rgba(215,253,239,1)",
                            ][i % 5],
                          }}
                          title={c.name}
                        >
                          <img
                            alt=""
                            src={`${c.product_room_categories[0].product.slug}/${selectedSize}.png`}
                            style={{ width: "100%" }}
                          />
                        </CardMedia>
                        <CardHeader
                          titleTypographyProps={{
                            variant: "h6",
                            noWrap: true,
                          }}
                          title={c.name}
                        ></CardHeader>
                      </Card>
                    </Box>
                  )
                })}
              </SSlider>
            </Box>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              component={Link}
              style={{ color: "white" }}
              to={queryString.stringifyUrl(
                {
                  url: "/shop",
                  query: {
                    categories: categories.category.map(c =>
                      c.name.toLowerCase()
                    ),
                    styles: ["air", "cube", "stacc"],
                  },
                },
                { arrayFormat: "bracket" }
              )}
            >
              Explore All Products
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Comp
